import React from 'react';

// Category options with emojis
const CATEGORIES = [
  { id: 'nature', label: 'Nature', emoji: '🌿' },
  { id: 'travel', label: 'Travel', emoji: '✈️' },
  { id: 'cars', label: 'Cars', emoji: '🚗' },
  { id: 'technology', label: 'Tech', emoji: '💻' },
  { id: 'food', label: 'Food', emoji: '🍕' },
  { id: 'people', label: 'People', emoji: '👥' },
  { id: 'architecture', label: 'Architecture', emoji: '🏗️' },
  { id: 'animals', label: 'Animals', emoji: '🦁' },
];

// Category filter component with sleek capsule buttons
const CategoryFilter = ({ selectedCategory, onCategoryChange }) => {
  return (
    <div className="flex gap-2 overflow-x-auto pb-2 -mx-4 px-4 sm:mx-0 sm:px-0 scrollbar-hide">
      {CATEGORIES.map((category) => (
        <button
          key={category.id}
          onClick={() => onCategoryChange(category.id)}
          className={`px-4 py-2 rounded-lg whitespace-nowrap text-sm font-medium transition-all duration-300 ${
            selectedCategory === category.id
              ? 'bg-gray-900 dark:bg-white text-white dark:text-black shadow-lg scale-105'
              : 'bg-gray-100 dark:bg-gray-900 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-800 hover:shadow-md'
          }`}
        >
          <span className="mr-2">{category.emoji}</span>
          {category.label}
        </button>
      ))}
    </div>
  );
};

export default CategoryFilter;
